module.exports = __webpack_public_path__ + "static/media/HomeHeader-bg-mobile-@1x.fcdb455f.png";